export default "__VITE_ASSET__vpKgkYoc__"